import React from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Container, Box, Paper, Typography, Link, Alert, Divider } from '@mui/material';
import { useAuthStore } from '../../store/authStore';
import GoogleSignInButton from '../../components/auth/GoogleSignInButton';
import Logo, { TAGLINE } from '../../components/brand/Logo';

/** Creating an account is signing in with Google: the same button, the same call. */
const RegisterPage: React.FC = () => {
  const navigate = useNavigate();
  const { isLoading, error, clearError } = useAuthStore();

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Box sx={{ textAlign: 'center', mb: 4 }}>
        <Typography component="h1" sx={{ m: 0, mb: 2.5, lineHeight: 1 }}>
          <Logo size={52} />
        </Typography>
        <Typography variant="h5" component="p" gutterBottom sx={{ fontWeight: 600 }}>
          {TAGLINE}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Fill applications in seconds with your saved profile and answers
        </Typography>
      </Box>

      <Paper elevation={4} sx={{ p: 4 }}>
        {error && (
          <Alert severity="error" sx={{ mb: 3 }} onClose={clearError}>
            {error}
          </Alert>
        )}

        <GoogleSignInButton
          onSignedIn={() => navigate('/dashboard', { replace: true })}
          disabled={isLoading}
        />

        <Typography variant="caption" color="text.secondary" component="p" sx={{ textAlign: 'center', mt: 1.5 }}>
          By continuing you agree to the{' '}
          <Link component={RouterLink} to="/terms">
            Terms of Service
          </Link>{' '}
          and{' '}
          <Link component={RouterLink} to="/privacy">
            Privacy Policy
          </Link>
          .
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            Already have an account?{' '}
            <Link component={RouterLink} to="/login" variant="body2" sx={{ fontWeight: 600 }}>
              Sign in
            </Link>
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default RegisterPage;
